export const isEmptyObject = input =>
  input && Object.keys(input).length === 0 && input.constructor === Object;

export const isObjectNotEmpty = input =>
  input && Object.keys(input).length > 0 && input.constructor === Object;
